module.exports = __webpack_public_path__ + "static/media/testimonial.d7439625.jpg";